import React, { useEffect } from "react";

import { getVSIFileIcon } from "file-extension-icon-js";

import { Badge, Checkbox } from "antd";

import {
  validarSePassouDaDataDeValidade,
  formatarData,
  getIconesExtensao,
} from "../../services/utils";

import TableHeader from "../Table/Header";
import TablePagination from "../Table/PaginationSemEspaco";

import favoritoSvg from "../../assets/icons/iconFavoritado.svg";
import pastaSvg from "../../assets/icons/pastaIcone.svg";

import "./styles.scss";

const ListagemItensCompartilhado = ({
  data,
  mudarPagina,
  buscarPastasFilhas,
  selecionarItemParaDownload,
  marcarTodosItens,
  isSelectAll,
}) => {
  const tabelaColunas = [
    <img src={favoritoSvg} />,
    <Checkbox
      checked={isSelectAll}
      onClick={(event) => marcarTodosItens(event.target.checked)}
      type="checkbox"
    >
      Selecionar
    </Checkbox>,
    "Nome",
    "Tamanho", 
  ];

  const handleEntrarVisualizar = (item) => {
    if (item.tipo == 0) {
      buscarPastasFilhas(item.id, item.nome, item.tipo);
    }
  };

  const preImagemArquivo = (item) => {
    const extensao = item.extensao ?? item.nome.split(".")[1];

    let nomeArquivo =
      !item.nome.includes(".") && extensao != null
        ? `${item.nome}.${extensao}`
        : item.nome;

    if (item.urlPreview) {
      return (
        <img
          src={item.urlPreview}
          className={
            validarSePassouDaDataDeValidade(item.dataVencimento)
              ? "pasta-arquivo-pos-validade "
              : ""
          }
        />
      );
    } else {
      return (
        <div style={{ maxHeight: "1.5rem", maxWidth: "1.5rem" }}>
          <img
             src={getIconesExtensao(extensao)}
            className={
              validarSePassouDaDataDeValidade(item.dataVencimento)
                ? "pasta-arquivo-pos-validade "
                : ""
            }
          />
        </div>
      );
    }
  };

  return (
    <div>
        <table className="table table-borderless" >
          <TableHeader columns={tabelaColunas} />
          <tbody>
            {(!data?.lista || data?.lista.length === 0) && (
              <tr>
                <td colSpan="7"> Sem Registros </td>
              </tr>
            )}
            {data?.lista &&
              data?.lista?.map((item, index) => (
                <tr key={index}>
                  <td onClick={() => handleEntrarVisualizar(item)}>
                    {item.ehFavorito ? (
                      <img src={favoritoSvg} />
                    ) : (
                      <Badge status="default" />
                    )}
                  </td>
                  <td className="d-flex justify-content-center">
                    <Checkbox
                      checked={item.checked}
                      onChange={(e) =>
                        selecionarItemParaDownload(e.target.checked, item)
                      }
                    ></Checkbox>
                  </td>
                  <td onClick={() => handleEntrarVisualizar(item)}>
                    <span className="coluna-nome">
                      {item.tipo == 1 ? (
                        preImagemArquivo(item)
                      ) : (
                        <img
                          src={pastaSvg}
                          alt="pasta"
                          className={
                            validarSePassouDaDataDeValidade(item.dataVencimento)
                              ? "pasta-arquivo-pos-validade "
                              : ""
                          }
                        />
                      )}
                      {item.nome.length > 20 && !item.nome.includes(" ") ? (
                        <span style={{ wordBreak: "break-word" }}>
                          {item.nome}
                        </span>
                      ) : (
                        <span>{item.nome}</span>
                      )}
                    </span>
                  </td>
                  <td onClick={() => handleEntrarVisualizar(item)}>
                    {" "}
                    {item.tamanho != 0 ? item.tamanho : " - "}{" "}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
    
      <div>
        <TablePagination data={data} changePage={mudarPagina} />
      </div>
    </div>
  );
};

export default ListagemItensCompartilhado;
